
<dashboardnav>
  <cradua-seismicdamagelist
  [seismicdamagelists]="seismicdamagelists$ | async"
  (seismicdamagelist)="onSubmitSeismicDamageList($event)"
  (deleteSeismicDamageListEvent)="onDeleteSeismicDamageList($event)"
  *ngIf="(isLoadingSeismicDamageList$ | async ) === false"
  >
</cradua-seismicdamagelist>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingSeismicDamageList$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
